import * as $ from 'jquery';
import {onSubmit} from 'Core/Events'
import {Notifications} from "Core/Notifications";

export const ConfirmAgain = (() => {
    const Selector = {
        FORM: '#formConfirmAgain',
        CONFIRM_KEY: '#confirmKey',
        SUBMIT: '#confirmSubmit',
        AFTER_DIV: '#afterConfirm'
    };

    function sendConfirmAgain(this, event) {
        event.preventDefault();
        $(Selector.SUBMIT).prop( "disabled", true );
        let url = '/' + $(Selector.FORM).attr("action");

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                confirmKey: $(Selector.CONFIRM_KEY).val()
            },
            dataType: 'json',
        })
        .done((res) => {
            let type = (res.status) ? 'success' : 'error';
            Notifications.add(res.msg, type);
            $(Selector.AFTER_DIV).removeClass('d-none');
        });
    }

    onSubmit(Selector.FORM, sendConfirmAgain);

})();import * as $ from 'jquery';
import {onSubmit} from 'Core/Events'
import {Notifications} from "Core/Notifications";

export const ConfirmAgain = (() => {
    const Selector = {
        FORM: '#formConfirmAgain',
        CONFIRM_KEY: '#confirmKey',
        SUBMIT: '#confirmSubmit',
        AFTER_DIV: '#afterConfirm'
    };

    function sendConfirmAgain(this, event) {
        event.preventDefault();
        $(Selector.SUBMIT).prop( "disabled", true );
        let url = '/' + $(Selector.FORM).attr("action");

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                confirmKey: $(Selector.CONFIRM_KEY).val()
            },
            dataType: 'json',
        })
        .done((res) => {
            let type = (res.status) ? 'success' : 'error';
            Notifications.add(res.msg, type);
            $(Selector.AFTER_DIV).removeClass('d-none');
        });
    }

    onSubmit(Selector.FORM, sendConfirmAgain);

})();